"use client"
import { Sheet, SheetContent } from "@/components/ui/sheet"
import Image from "next/image"
import { mobile_navLinks } from "@/utils"
import { usePathname, useRouter } from "next/navigation"
import { DialogTitle } from "@/components/ui/dialog"

/**
 * This component renders a drawer for navigation and authentication of the app, only in the mobile version.
 * @param {Function} setOpenDrawer - Function to set the drawer open state
 * @param {boolean} openDrawer - State to control if the drawer is open
 */
const MobileDrawer = ({ setOpenDrawer, openDrawer }) => {
  const router = useRouter()
  const path = usePathname()

  const goToLink = (href) => {
    setOpenDrawer(false)
    router.push(href)
  }

  const handleScroll = (e, target, offset = 0) => {
    setOpenDrawer(false)
    e.preventDefault()
    const element = document.querySelector(target)
    const elementPosition = element.getBoundingClientRect().top + window.scrollY
    const offsetPosition = elementPosition - offset
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  return (
    <Sheet open={openDrawer} onOpenChange={setOpenDrawer}>
      <SheetContent side="left" className="p-0 w-[250px] flex flex-col justify-between items-center py-10">
          <nav className="h-[80%] w-full flex flex-col justify-start items-start px-3 gap-y-4 mt-10">
            <DialogTitle className="flex flex-col items-start w-full gap-y-2">
              <button type="button" className="text-base font-semibold" onClick={() => goToLink("/")}>
                Home
              </button>
              <span className="w-full h-px bg-gray-400"></span>
            </DialogTitle>

            {path === "/" &&
              mobile_navLinks.map((item) => (
                <div key={item.title} className="flex flex-col items-start w-full gap-y-2">
                  <button type="button" onClick={(e) => handleScroll(e, item.scroll, item.offset)}>
                    <h4 className="text-base font-semibold">{item.title}</h4>
                  </button>
                  <span className="w-full h-px bg-gray-400"></span>
                </div>
              ))}
          </nav>
          <Image src={"/marineBroker/logo.png"} priority width={120} height={100} alt="Logo marine brokers" className="w-32" />
      </SheetContent>
    </Sheet>
  )
}

export default MobileDrawer

